export default "__VITE_ASSET__CRtHaPvS__"